// authActions.js — thunks → authServices (DealCouponz pattern)
import * as authTypes from "../types/authTypes";
import * as authServices from "../../services/authServices";
import { AUTH_TOKEN_KEY } from "../../config/authToken";
import { clearUserPortfolio } from "./userActions";

export const completePasswordReset = (token, password) => async (dispatch) => {
  dispatch({ type: authTypes.LOGIN_REQUEST });
  try {
    const data = await authServices.resetPasswordWithToken(token, password);
    window.localStorage.setItem(AUTH_TOKEN_KEY, data.token);
    dispatch({
      type: authTypes.LOGIN_SUCCESS,
      payload: { token: data.token, user: data.user },
    });
    return true;
  } catch (e) {
    const msg =
      e?.response?.data?.message || e?.message || "Could not reset password";
    dispatch({ type: authTypes.LOGIN_FAILURE, payload: msg });
    return false;
  }
};

export const loginUser = (email, password) => async (dispatch) => {
  dispatch({ type: authTypes.LOGIN_REQUEST });
  try {
    const data = await authServices.loginUser({ email, password });
    window.localStorage.setItem(AUTH_TOKEN_KEY, data.token);
    dispatch({
      type: authTypes.LOGIN_SUCCESS,
      payload: { token: data.token, user: data.user },
    });
  } catch (e) {
    const msg =
      e?.response?.data?.message || e?.message || "Could not sign in";
    dispatch({ type: authTypes.LOGIN_FAILURE, payload: msg });
  }
};

export const registerUser = ({ name, email, password }) => async (dispatch) => {
  dispatch({ type: authTypes.REGISTER_REQUEST });
  try {
    const data = await authServices.registerUser({ name, email, password });
    window.localStorage.setItem(AUTH_TOKEN_KEY, data.token);
    dispatch({
      type: authTypes.REGISTER_SUCCESS,
      payload: { token: data.token, user: data.user },
    });
  } catch (e) {
    const msg =
      e?.response?.data?.message || e?.message || "Could not register";
    dispatch({ type: authTypes.REGISTER_FAILURE, payload: msg });
  }
};

export const restoreSession = () => async (dispatch) => {
  const token = window.localStorage.getItem(AUTH_TOKEN_KEY);
  if (!token) return;
  dispatch({ type: authTypes.RESTORE_REQUEST });
  try {
    const user = await authServices.getMe();
    dispatch({
      type: authTypes.RESTORE_SUCCESS,
      payload: { token, user },
    });
  } catch {
    window.localStorage.removeItem(AUTH_TOKEN_KEY);
    dispatch({ type: authTypes.RESTORE_FAILURE });
  }
};

export const logoutUser = () => (dispatch) => {
  window.localStorage.removeItem(AUTH_TOKEN_KEY);
  dispatch(clearUserPortfolio());
  dispatch({ type: authTypes.LOGOUT });
};
